module.exports = __webpack_public_path__ + "img/logo2.4de31de4.png";